




























































































































































































































































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import {
  POSContact,
  POSPayment,
  POSPaymentMethod,
  POSProductCategory,
  POSProductCollectorData,
  POSProductType,
  POSProductTypeData,
  POSSession,
  POSTicket,
  POSTicketDetail,
} from '@pos/interfaces/pos-v2';
import Vue from 'vue';
import BpcPosKeyboardV2 from '@pos/components/v2/pos-keyboard-v2.vue';
import BpcPosPaymentMethods from '@pos/components/v2/pos-payment-methods.vue';
import BpcPosTicketActions from '@pos/components/v2/pos-ticket-actions.vue';
import BpcPosPaymentList from '@pos/components/v2/pos-payment-list.vue';
import BpcPosPageContainer from '@pos/components/v2/pos-page-container.vue';
import BpcPosTicketTabs from '@pos/components/v2/pos-ticket-tabs.vue';
import BpcPosContact from '@pos/components/v2/pos-contact.vue';
import BpcPosContactDetails from '@pos/components/v2/pos-contact-details.vue';
import BpcPosTicketDetail from '@pos/components/v2/pos-ticket-detail.vue';
import BpcPosProductCategories from '@pos/components/v2/pos-product-categories.vue';
import BpcPosFmiByResource from '@pos/components/v2/pos-fmi-by-resource.vue';
import BpcPosAccessControlEvents from '@pos/components/v2/pos-access-control-events.vue';
import BpcPosLastContactAccess from '@pos/components/v2/pos-last-contact-access.vue';
import BpcPosConfirmPaymentModal from '@pos/components/v2/pos-confirm-payment-modal.vue';
import BpcPosWipayPaymentModal from '@pos/components/v2/pos-wipay-payment-modal.vue';
import BpcPosNeptingPaymentModal from '@pos/components/v2/pos-nepting-payment-modal.vue';
import BpcPosAdjustQuantityModal from '@pos/components/v2/pos-adjust-quantity-modal.vue';
import BpcPosPriceEditionModal from '@pos/components/v2/pos-price-edition-modal.vue';
import BpcPosAskOriginModal from '@pos/components/v2/pos-ask-origin-modal.vue';
import BpcPosSearchTicketModal from '@pos/components/v2/pos-search-ticket-modal.vue';
import BpcPosProductDataCollectorModal from '@pos/components/v2/pos-product-data-collector-modal.vue';
import { DownloadPdfUsingTemplateModel } from '@tools/interfaces/template';
import BpcPosSpecifyBadgeModal from '@pos/components/v2/pos-specify-badge-modal.vue';
import BcPosCashMovementsModal from '@pos/components/v2/pos-cash-movements-modal.vue';

@Component({
  name: 'bpc-pos-page',
  components: {
    BpcPosProductDataCollectorModal,
    BpcPosKeyboardV2,
    BpcPosPaymentMethods,
    BpcPosTicketActions,
    BpcPosPaymentList,
    BpcPosPageContainer,
    BpcPosTicketTabs,
    BpcPosContact,
    BpcPosTicketDetail,
    BpcPosProductCategories,
    BpcPosFmiByResource,
    BpcPosAccessControlEvents,
    BpcPosLastContactAccess,
    BpcPosConfirmPaymentModal,
    BpcPosWipayPaymentModal,
    BpcPosNeptingPaymentModal,
    BpcPosAdjustQuantityModal,
    BpcPosContactDetails,
    BpcPosPriceEditionModal,
    BpcPosAskOriginModal,
    BpcPosSearchTicketModal,
    BpcPosSpecifyBadgeModal,
    BcPosCashMovementsModal,
  },
})
export default class PosPage extends Vue {
  // PROPS
  @Prop({ type: String, default: null }) readonly initialPosSessionId: string | null;
  @Prop({ type: String, default: null }) readonly initialTicketId: string | null;
  // DATA
  paymentMethodOptions: POSPaymentMethod[] = [];
  paymentMethodLoaded = false;
  askForBadgeOnMounted = false;
  AskOnMountedOrderItemId: number = null;
  showConfirmPaymentModal = false;
  showAddBadgeModal: boolean = false;
  specifyBadgeConfirmBtnDisabled: boolean = false;
  addingBadge: boolean = false;
  showCashMovementsModal: boolean = false;
  cashMovementType: string = null;

  // TODO add real ticket
  currentTicket: POSTicket = null;
  ticketDetail: POSTicketDetail = null;
  currentContact: POSContact = null;
  ticketProductTypes: POSProductTypeData[] = [];
  ticketPayments: POSPayment[] = [];
  changingTicket: boolean = false;
  amountToPay: number = 0;
  posSession: POSSession = null;
  selectedPaymentMethod: string = null;
  savingPayment = false;
  activitySessionReloadKey: number = 1;
  openedTicketReloadKey: number = 1;
  showAdjustQuantityModal: boolean = false;
  productCategoryEntry: POSProductCategory = null;
  showContactDetails: boolean = false;
  showPriceEditionModal: boolean = false;
  discountProductId: number = null;
  discountProductQuantity: number = 0;
  discountProductPrice: number = 0;
  dicountEditPriceAllowed: boolean = false;
  discountEditedPrice: boolean = false;
  discountDescription: string = '';
  discountType: string = '';
  discount: number = 0;
  editableQuantity: boolean = false;
  allowNegativeQuantity: boolean = false;
  showAskOriginModal: boolean = false;
  askedForOrigin: boolean = false;
  showSearchTicketModal: boolean = false;
  refreshContactListKey: number = 1;
  // For product collector data modal
  productDataCollectorModalTitle: string = '';
  showProductDataCollectorModal: boolean = false;
  selectedProductType: POSProductType = null;
  selectedProductCategory: POSProductCategory = null;
  // COMPUTED

  get amountToBePaid(): number {
    return this.ticketDetail?.balance || 0;
  }

  get currentTicketId(): number | null {
    return this.currentTicket ? this.currentTicket.id : null;
  }

  get posSessionId(): number | null {
    return this.posSession ? this.posSession.id : null;
  }

  get isCashMovementsEnabled(): boolean {
    return this.posSession ? this.posSession.cashMovementsEnabled : false;
  }

  get askForOriginRequired() {
    return this.posSession.askOrigin;
  }

  get posSessionReopened(): boolean {
    return this.posSession?.status === 'reopened';
  }

  get currentContactId(): number {
    return this.currentContact?.id;
  }

  get isAnonymousContact(): boolean {
    return !this.currentContact ? true : this.currentContact?.type === 'anonymous';
  }

  get readOnlyTicket(): boolean {
    return this.ticketDetail ? !this.ticketDetail.canBeModified : false;
  }

  /* Lifecycle hooks */
  // created() {}
  async mounted() {
    await this.getCurrentPosSession(Number(this.initialPosSessionId));
    await this.getPaymentMethodOptions();
    await this.getMountedActions();
  }

  // updated() {}
  // destroyed() {}

  // METHODS
  onTicketProductsUpdated(model: POSProductTypeData[]) {
    this.ticketProductTypes = model;
    this.activitySessionReloadKey++;
  }

  onPaymentMethodTypeUpdated() {
    this.getTicketDetail();
  }

  async onTicketReopen() {
    const ticketDetail = await this.$posService.reopenTicket(
      this.posSessionId,
      this.currentTicketId,
    );
    this.refreshTicketDetail(ticketDetail);
  }

  async getTicketDetail() {
    const ticketDetail = await this.$posService.getTicketDetail(
      this.posSessionId,
      this.currentTicketId,
    );

    this.refreshTicketDetail(ticketDetail);
  }

  onCheckoutTicket($event: POSTicket) {
    if (this.currentTicket?.id !== $event.id) {
      this.currentTicket = $event;
      this.openedTicketReloadKey++;
    } else {
      this.getTicketDetail();
    }
  }

  async getCurrentPosSession(posSessionId: number | null = null) {
    console.log(posSessionId);
    this.posSession = await this.$posService.getPosSession(posSessionId);
  }

  async getPaymentMethodOptions(): Promise<void> {
    if (this.posSessionId) {
      this.paymentMethodLoaded = false;
      this.paymentMethodOptions = await this.$posService.getPaymentMethodOptions(this.posSessionId);
      this.paymentMethodLoaded = true;
    }
  }

  async getMountedActions() {
    const action = this.$route.query.action;
    const orderItemId = this.$route.query.orderItemId;
    this.$router.replace({ query: {} });
    switch (action) {
      case 'askForBadge':
        this.askForBadgeOnMounted = true;
        this.AskOnMountedOrderItemId = Number(orderItemId);
        break;
    }
  }

  async addProductToTicket(productCategory: POSProductCategory) {
    this.changingTicket = true;
    if (!this.currentTicket) {
      this.changingTicket = false;
      return;
    }
    if (this.ticketDetail.status !== 'to_pay') {
      this.$bpcMessage.showErrorMessage({ text: 'pos.ticket_already_paid' });
      return;
    }
    try {
      if (this.isAnonymousContact && !productCategory.availableForAnonymousContact) {
        this.$bpcMessage.showErrorMessage({
          text: 'pos.error_product_not_allowed_for_anonymous_client',
        });
      } else if (productCategory.adjustableQuantity) {
        this.showAdjustQuantityModal = true;
        this.productCategoryEntry = productCategory;
      } else if (productCategory.useSEPA) {
        this.selectedProductType = productCategory.productType;
        this.selectedProductCategory = productCategory;
        this.productDataCollectorModalTitle = this.$t(
          'pos.product_data_collector_modal_subscription_sepa',
        ).toString();
        this.showProductDataCollectorModal = true;
      } else if (productCategory.requiredSecondaryBadge) {
        this.selectedProductType = productCategory.productType;
        this.selectedProductCategory = productCategory;
        this.showAddBadgeModal = true;
      } else {
        const ticket = await this.$posService.addProductToTicket(
          this.posSessionId,
          this.currentTicket.id,
          productCategory,
          1,
        );
        this.refreshTicketDetail(ticket);
      }
    } catch (error) {
      this.activitySessionReloadKey++;
    }
    this.changingTicket = false;
  }

  onOpenCashMovementModal(type: string) {
    this.showCashMovementsModal = true;
    this.cashMovementType = type;
  }

  onCloseAdjustQuantityModal() {
    this.showAdjustQuantityModal = false;
    this.changingTicket = false;
  }

  async onConfirmAdjustableQuantityModal(product) {
    this.showAdjustQuantityModal = false;
    try {
      const ticket = await this.$posService.addProductToTicket(
        this.posSessionId,
        this.currentTicket.id,
        product.productCategory,
        product.quantity,
        {
          manualAccessEvent: product.manualAccessEvent,
          selectedRessourceId: product.selectedRessourceId,
          badgeNumber: product.badgeNumber,
          badgeType: 'rfid',
        },
      );
      this.refreshTicketDetail(ticket);
    } catch (error) {
      this.activitySessionReloadKey++;
    }
    this.changingTicket = false;
  }

  async onConfirmAddBadgeModal(badgeNumber) {
    const productCategory: POSProductCategory = this.selectedProductCategory;
    this.specifyBadgeConfirmBtnDisabled = true;
    this.addingBadge = true;

    try {
      const ticket = await this.$posService.addProductToTicket(
        this.posSessionId,
        this.currentTicket.id,
        productCategory,
        1,
        {
          badgeNumber: badgeNumber,
          badgeType: 'rfid',
        },
      );
      this.refreshTicketDetail(ticket);
      this.showAddBadgeModal = false;
      this.specifyBadgeConfirmBtnDisabled = false;
      this.addingBadge = false;
    } catch (error) {
      this.activitySessionReloadKey++;
      this.specifyBadgeConfirmBtnDisabled = false;
      this.addingBadge = false;
    }
    this.changingTicket = false;
  }

  onCloseAskOriginModal() {
    this.showAskOriginModal = false;
    this.onPaymentMethodClicked(this.selectedPaymentMethod);
  }
  onCloseSearchTicketModal() {
    this.showSearchTicketModal = false;
  }

  async onTicketAskedForOrigin(ticketDetail: POSTicketDetail) {
    this.refreshTicketDetail(ticketDetail);
    this.onPaymentMethodClicked(this.selectedPaymentMethod);
  }

  restartAskForOriginProperties() {
    this.askedForOrigin = false;
    this.showAskOriginModal = false;
  }

  onPaymentMethodClicked(method) {
    // TODO: If payment method requires a terminal,
    // show a previous modal to select the terminal
    this.selectedPaymentMethod = method;
    if (this.askForOriginRequired && !this.askedForOrigin && !this.ticketDetail.origin) {
      this.showAskOriginModal = true;
      this.askedForOrigin = true;
    } else {
      // Display modal to confirm
      this.showConfirmPaymentModal = true;
    }
  }

  onTicketClosed() {
    this.currentTicket = null;
    this.ticketDetail = null;
    this.currentContact = null;
    this.ticketProductTypes = [];
    this.ticketPayments = [];
    this.openedTicketReloadKey++;
    this.showConfirmPaymentModal = false;
  }

  onTicketMarkedAsPaid(ticketDetail: POSTicketDetail) {
    this.refreshTicketDetail(ticketDetail);
  }

  refreshTicketDetail(ticketDetail: POSTicketDetail) {
    if (ticketDetail.contact) {
      this.currentContact = ticketDetail.contact;
    }

    if (ticketDetail.payments) {
      this.ticketPayments = ticketDetail?.payments || [];
    }

    if (ticketDetail.productTypes) {
      this.ticketProductTypes = ticketDetail.productTypes;
    }

    this.ticketDetail = ticketDetail;

    this.activitySessionReloadKey++;
  }

  onPriceEditionClicked(productPayload) {
    const product = productPayload.product;
    const productCategory = productPayload.productCategory;
    this.discountProductId = Number(product.id);
    this.discountProductQuantity = product.quantity;
    this.discountProductPrice = product.price;
    this.dicountEditPriceAllowed = product.editablePrice;
    this.editableQuantity = productCategory.config.adjustableQuantity;
    this.allowNegativeQuantity = productCategory.config.allowNegativeQuantity;
    this.discountDescription = product.description;
    this.discountEditedPrice = product.editedPrice;
    this.discountType = product.discountType;
    this.discount = product.discount;
    this.showPriceEditionModal = true;
  }

  onPriceEdited(ticket: POSTicketDetail) {
    this.discountProductId = null;
    this.showPriceEditionModal = false;
    this.refreshTicketDetail(ticket);
  }

  refreshContactInTicketDetail(contact: POSContact) {
    this.ticketDetail.contact = contact;
    this.currentContact = contact;
  }

  seeMoreClicked() {
    this.showContactDetails = true;
  }

  onOpenTicket(ticket: POSTicket) {
    this.currentTicket = ticket;
    this.showSearchTicketModal = false;
  }

  onReopenTicketFromSearch(ticket: POSTicket) {
    this.currentTicket = ticket;
    this.onTicketReopen();
    this.showSearchTicketModal = false;
    this.openedTicketReloadKey++;
  }

  closeProductDataCollectorModal() {
    this.showProductDataCollectorModal = false;
  }

  async onProductDataCollected(data: POSProductCollectorData) {
    this.changingTicket = true;

    // Get the current products with mandate to avoid printing everything each time
    const currentProductsWithMandate =
      this.ticketDetail.productTypes
        ?.find(item => item.type === 'subscription')
        ?.products?.filter(product => !!product.mandateId)
        ?.map(product => {
          return product.mandateId;
        }) || [];

    try {
      const ticket = await this.$posService.addProductToTicket(
        this.posSessionId,
        this.currentTicket.id,
        data.productCategory,
        data.quantity,
        data.extraData,
      );
      this.refreshTicketDetail(ticket);
    } catch (error) {
      this.activitySessionReloadKey++;
    }

    this.closeProductDataCollectorModal();
    this.changingTicket = false;

    // Possible additional actions
    if (data.extraData.printSepa) {
      // Get the new product in the ticket to print only that one
      const mandateIdToPrint =
        this.ticketDetail.productTypes
          ?.find(item => item.type === 'subscription')
          ?.products?.filter(
            product =>
              !!product.mandateId && !currentProductsWithMandate.includes(product.mandateId),
          )
          ?.map(product => {
            return product.mandateId;
          }) || [];

      const templateId = this.$store.getters['centerSettings/centerSettings']?.sepa_template_id;
      await this.$printTemplateService.printTemplate('mandate', mandateIdToPrint, templateId);
    }
  }

  async downloadPdfToPrint(formModel: DownloadPdfUsingTemplateModel) {
    const path = `${this.$bpcApiRouteHelper.getEntityPath('templates')}/pdf-to-print`;
    return await this.$bpcApi.post(path, formModel).toPromise();
  }

  onTicketChanged() {
    this.refreshContactListKey++;
  }

  @Watch('amountToBePaid')
  onAmountToBePaidChanged(newAmount: number) {
    this.amountToPay = newAmount;
  }

  @Watch('posSessionId')
  onPosSessionIdChanged(newPosSessionId: number) {
    if (newPosSessionId) {
      this.getPaymentMethodOptions();
    }
  }
  @Watch('currentTicketId')
  onCurrentTicketIdChanged(newTicketId: number) {
    if (newTicketId) {
      this.restartAskForOriginProperties();
      this.getTicketDetail();
    }
  }
}
